import React from 'react';

import { DatabaseSortOrder, DatabasesQueryVariables, DatabasesQuery, DatabasesDisplayGridRowDataFragment, DatabasesByTagQueryVariables, DatabasesByTagQuery , DatabasesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataWithMaxCountsForDatabase } from '../database/functions/DatabaseRowDataFunctions';
import { DatabasesDisplayGridRowData } from '../database/types/DatabasesDisplayGridRowData';
import { DatabasesDisplayGrid } from '../sharedDisplayGrid/DatabasesDisplayGrid';
import { DatabasesValidSortFields } from '../sorting/sortProviders/DatabasesGridSortProvider';

export type QueryVariables = DatabasesQueryVariables;
export type QueryResults = DatabasesQuery;
export type QueryResultListNode = DatabasesDisplayGridRowDataFragment;

export type QueryVariablesWithTagFilter = DatabasesByTagQueryVariables;
export type QueryResultsWithTagFilter = DatabasesByTagQuery;
export type QueryResultListNodeWithTagFilter = DatabasesDisplayGridRowDataFragment;

export type GridRowData = DatabasesDisplayGridRowData;

export function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databasesConnection;
}

export function selectConnectionListResultWithTagFilter(
  resultData: QueryResultsWithTagFilter
): ConnectionListResult<QueryResultListNodeWithTagFilter> | null {
  return resultData?.tags?.[0]?.databasesConnection ?? null
}

export type DatabasesExplorerQueryGridProps = GridSortProps<DatabasesValidSortFields>;

// This component is used only from the example. In the actual app, we render the Databases Explorer via
// VizPortal's "Explorer" instead, using these result mappers and the columns from the DatabasesDisplayGrid.
export function DatabasesExplorerQueryGrid(props: DatabasesExplorerQueryGridProps): JSX.Element {
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={DatabasesDocument}
      partialQueryVariables={{
        orderBy: props.orderBy as DatabaseSortOrder,
        hasActiveWarning: null,
        isCertified: null,
        textSearch: null,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataWithMaxCountsForDatabase}
    >
      {({ rowStore }) => (
        <DatabasesDisplayGrid
          rowStore={rowStore}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
